import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import "../styles/SubmitTicket.css";

export default function SubmitTickets() {
  const { user } = useAuth();

  const displayName = useMemo(() => {
    if (!user) return "there";
    const base =
      user.displayName ||
      user.name ||
      user.username ||
      (user.email ? user.email.split("@")[0] : "there");
    return base
      .toString()
      .trim()
      .split(/\s+/)[0];
  }, [user]);

  return (
    <div className="ticketing-title-container">
      <div className="ticket-shell ticket-shell--simple">
        {/* Header */}
        <div className="ticket-header">
          <div>
            <h2 className="ticket-title">Your Help Desk Tickets</h2>
            <p className="ticket-sub">
              All of your IT issues, requests, and updates live in the Help Desk
              workspace.
            </p>
          </div>

          <div className="ticket-actions"></div>
        </div>

        {/* Centered hero / empty state */}
        <div className="ticket-hero-wrapper">
          <div className="ticket-hero-card">
            <div className="ticket-pill">Help Desk</div>

            <h3 className="ticket-hero-title">
              Hi {displayName}, your Help Desk moved here
            </h3>

            <p className="ticket-hero-sub">
              Use the Help Desk view to create new tickets, upload screenshots,
              and follow progress in real time. Everything is in one place for
              you and IT.
            </p>

            <ul className="ticket-hero-list">
              <li>Submit new issues and requests</li>
              <li>Track status, SLA timers, and comments</li>
              <li>View your full ticket history</li>
            </ul>

            <Link
              to="/submitted-tickets"
              rel="noopener noreferrer"
              target="_blank"
              className="ticket-hero-cta"
            >
              Open Help Desk
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
